import { useState, useEffect } from 'react';

export const useAnimatedHeight = ({ ref }) => {
  const [height, setHeight] = useState('auto');

  const styledHeight = {
    height,
    transition: 'all 0.3s ease-in-out',
    overflow: 'hidden',
  };

  useEffect(() => {
    if (!ref?.current) return;

    const obeserver = new ResizeObserver((entries) => {
      const currentRefHeight = entries?.[0]?.target?.scrollHeight;
      setHeight(currentRefHeight);
    });

    if (ref?.current) obeserver.observe(ref?.current);

    return () => obeserver.disconnect();
  }, [ref]);

  return [styledHeight];
};
